import { EarningMechanismConfigurationInput, OfferFragment } from '@occc/graphql';
import { Operation } from '@occc-app/offerHelpers/types';
import { makeEarningMechanismCreateOperation } from '@occc-app/offerHelpers/operations/earningMechanism';
import { earningMechanismInputCreator } from '@occc-app/offerHelpers/earningMechanismInputCreator';

import { GameConfigureFormValues } from '../../types';
import { makeDeleteOperation } from '../../../../offerHelpers/operations/makeDeleteOperation';

type EarningMechanismCreateInput = Pick<EarningMechanismConfigurationInput, 'spinWheelGame'>;

type GetEarningMechanismCreateInput = (
  values: GameConfigureFormValues,
) => EarningMechanismCreateInput;

const getEarningMechanismCreateInput: GetEarningMechanismCreateInput = (values) => {
  const {
    gameType,
    name,
    description,
    segments,
    fulfillmentWindow,
    awardCount,
    purchasableOffer,
    spinWheelGameConfig,
  } = values;

  return earningMechanismInputCreator.createSpinWheelGame({
    gameType,
    name,
    description,
    segments,
    fulfillmentWindow,
    awardCount,
    purchasableOffer,
    spinWheelGameConfig,
  });
};

export const getEarningMechanismOperations = (
  offerId: string,
  offer: OfferFragment | undefined,
  values: GameConfigureFormValues,
): Operation[] => {
  if (!offer) {
    return [];
  }
  const operations: Operation[] = [];

  if (offer.earningMechanism?.id) {
    operations.push(makeDeleteOperation('earningMechanismDelete', offer.earningMechanism?.id));
  }

  const configuration = getEarningMechanismCreateInput(values);
  operations.push(makeEarningMechanismCreateOperation(offerId, configuration));

  return operations;
};
